var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"float-left"}),(_vm.$route.fullPath == '/faqs')?_c('router-link',{staticClass:"btn-basic mt-4 float-right",attrs:{"to":"/faqs/new-faq"}},[_vm._v("New FAQ\n  ")]):_vm._e(),_c('br'),_c('br'),_c('br'),_c('br'),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }